__turbopack_context__.v({
  "helios-page-intro": "oljoxW_helios-page-intro",
  "helios-page-intro__inner--center": "oljoxW_helios-page-intro__inner--center",
  "helios-page-intro__meta": "oljoxW_helios-page-intro__meta",
  "helios-page-intro__subtitle": "oljoxW_helios-page-intro__subtitle",
  "helios-page-intro__subtitle--as-div": "oljoxW_helios-page-intro__subtitle--as-div",
  "helios-page-intro__subtitle--as-h2": "oljoxW_helios-page-intro__subtitle--as-h2",
  "helios-page-intro__subtitle--as-h3": "oljoxW_helios-page-intro__subtitle--as-h3",
  "helios-page-intro__subtitle--as-p": "oljoxW_helios-page-intro__subtitle--as-p",
  "helios-page-intro__subtitle--body": "oljoxW_helios-page-intro__subtitle--body",
  "helios-page-intro__subtitle--center": "oljoxW_helios-page-intro__subtitle--center",
  "helios-page-intro__subtitle--heading": "oljoxW_helios-page-intro__subtitle--heading",
  "helios-page-intro__subtitle--mobile-display": "oljoxW_helios-page-intro__subtitle--mobile-display",
  "helios-page-intro__subtitle--scale-body": "oljoxW_helios-page-intro__subtitle--scale-body",
  "helios-page-intro__subtitle--scale-lead": "oljoxW_helios-page-intro__subtitle--scale-lead",
  "helios-page-intro__subtitle--spacing-default": "oljoxW_helios-page-intro__subtitle--spacing-default",
  "helios-page-intro__title": "oljoxW_helios-page-intro__title",
  "helios-page-intro__title--lg": "oljoxW_helios-page-intro__title--lg",
  "helios-page-intro__title--with-meta": "oljoxW_helios-page-intro__title--with-meta",
  "helios-page-intro__title--xl": "oljoxW_helios-page-intro__title--xl",
});
